import type { CoiListRow } from "@/hooks/useCois";

export interface BdPeopleRow extends CoiListRow { touches: number }

/**
 * The people table. For a person: the COIs they own or touched in the period,
 * with their own touch count. Sorted by last touch, most recent first; a person
 * never touched sorts last, with no warning attached.
 */
export function bdPeopleRows(
  rows: CoiListRow[],
  opts: { who: string; touchesByCoi: Record<string, number>; search: string; specialty: string },
): BdPeopleRow[] {
  const q = opts.search.trim().toLowerCase();
  return rows
    .filter((c) => opts.who === "all" || c.ownerUserId === opts.who || (opts.touchesByCoi[c.id] ?? 0) > 0)
    .filter((c) => opts.specialty === "all" || c.specialty === opts.specialty)
    .filter((c) => !q || [c.name, c.firmName, c.geographicCoverage, c.ownerName].some((v) => v?.toLowerCase().includes(q)))
    .map((c) => ({ ...c, touches: opts.touchesByCoi[c.id] ?? 0 }))
    .sort((a, b) => {
      if (!a.lastTouch && !b.lastTouch) return a.name.localeCompare(b.name);
      if (!a.lastTouch) return 1;
      if (!b.lastTouch) return -1;
      return Date.parse(b.lastTouch.at) - Date.parse(a.lastTouch.at);
    });
}
